<xemex-table
  [columns]="columns"
  [data]="tableData()"
  [loading]="isLoading()"
  [totalCount]="totalCount() ?? 0"
  [pageSize]="pageSize"
  (pageChange)="onPageChange($event)"
>
  <xemex-table-filter-bar
    [filterGroups]="filterGroups()"
    [initialFilters]="initialFilters()"
    [searchPlaceholder]="'devices.detailTabs.activity.filter.initiator' | translate"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
  >
    <div actions class="flex items-center gap-2">
      <xemex-activity-date-range (rangeChange)="onDateRangeChange($event)" />
    </div>
  </xemex-table-filter-bar>

  <ng-template #actionsCell let-row>
    @if (row['_isRowClickable']) {
      <button
        mat-icon-button
        [matTooltip]="'general.view' | translate"
        (click)="openActionDialog(row); $event.stopPropagation()"
      >
        <mat-icon>{{ row['_actionIcon'] }}</mat-icon>
      </button>
    }
    @if (row['_hasMessage']) {
      <button
        mat-icon-button
        [matTooltip]="'general.viewMessage' | translate"
        (click)="openMessageDialog(row); $event.stopPropagation()"
      >
        <mat-icon>article</mat-icon>
      </button>
    }
  </ng-template>
</xemex-table>
